<template>
  <div>
    <div class="md:flex md:justify-between lg:justify-around">
      <div
        class="md:w-5/12 lg:w-3/12 p-4 rounded-lg mb-4 md:mb-0 bg-white bg-opacity-25 text-center"
      >
        <div
          class="text-custom text-xl lg:text-2xl mb-5 md:mb-0 leading-none font-medium"
        >
          Total Users
        </div>
        <div class="text-white my-2">
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            class="users mx-auto w-20 h-20"
          >
            <path
              d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
            ></path>
          </svg>
        </div>
        <div class="md:text-3xl font-bold my-1 text-white">
          {{ totalUsersCount }}
        </div>
      </div>
      <div
        class="md:w-6/12 lg:w-4/12 p-4 px-8 rounded-lg mb-4 md:mb-0 bg-white bg-opacity-25 text-center"
      >
        <div
          class="text-custom text-xl lg:text-2xl mb-5 md:mb-0 leading-none font-medium"
        >
          Active Subscribers
        </div>
        <div class="text-white my-2">
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            class="users mx-auto w-20 h-20"
          >
            <path
              d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
            ></path>
          </svg>
        </div>
        <div class="md:text-3xl font-bold my-1 text-white">
          {{ (activeSubscribersData || {}).total }}
        </div>
        <div class="my-2 md:flex justify-between" v-if="activeSubscribersData">
          <div
            class="yearly"
            v-for="(value, key) in activeSubscribersData.subscriptionsPlans"
            v-bind:key="key"
          >
            <div class="text-custom lg:text-lg">
              {{ key }}
            </div>
            <div class="text-white text-lg md:text-xl lg:text-2xl">
              {{ value }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      class="mt-5 lg:w-4/5 text-center md:text-left mx-auto md:flex p-5 md:p-10 rounded-lg bg-white bg-opacity-25"
    >
      <div class="leftSide md:w-1/2 md:mr-5">
        <div class="text-custom text-xl lg:text-2xl leading-none font-medium">
          Manage Subscriptions
        </div>
        <div class="w-full overflow-y-hidden">
          <table
            class="w-full text-left text-white mb-4"
            style="border-collapse:collapse"
          >
            <thead>
              <tr>
                <th
                  class="py-4 px-2 md:px-4 bg-grey-lighter font-sans font-medium uppercase text-sm text-grey border-b border-grey-light"
                >
                  Username
                </th>
                <th
                  class="py-4 px-2 md:px-4 bg-grey-lighter font-sans font-medium uppercase text-sm text-grey border-b border-grey-light"
                >
                  Package
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="hover:bg-blue-lightest">
                <td class="py-4 px-2 md:px-4 border-b border-grey-light">
                  Sigma 101
                </td>
                <td class="py-4 px-2 md:px-4 border-b border-grey-light">
                  Yearly
                </td>
              </tr>
              <tr class="hover:bg-blue-lightest">
                <td class="py-4 px-2 md:px-4 border-b border-grey-light">
                  Sigma 121
                </td>
                <td class="py-4 px-2 md:px-4 border-b border-grey-light">
                  Monthly
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mb-12 md:mb-1">
          <router-link
            to="javascrip:void(0)"
            class="btn py-1 text-white font-medium"
            >View All</router-link
          >
        </div>
      </div>
      <div class="rightSide md:w-1/2">
        <div class="text-custom text-xl lg:text-2xl leading-none font-medium">
          Manage Referrals
        </div>
        <div class="w-full overflow-y-hidden">
          <table
            class="w-full text-left text-white mb-4"
            style="border-collapse:collapse"
          >
            <thead>
              <tr>
                <th
                  class="py-4 px-2 md:px-4 bg-grey-lighter font-sans font-medium uppercase text-sm text-grey border-b border-white"
                >
                  Username
                </th>
                <th
                  class="py-4 px-2 md:px-4 bg-grey-lighter font-sans font-medium uppercase text-sm text-grey border-b border-white"
                >
                  Package
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="hover:bg-blue-lightest">
                <td class="py-4 px-2 md:px-4 border-b border-grey-light">
                  Sigma 101
                </td>
                <td
                  class="py-4 px-2 md:px-4 border-b border-grey-light text-center"
                >
                  Yearly
                </td>
              </tr>
              <tr class="hover:bg-blue-lightest">
                <td class="py-4 px-2 md:px-4 border-b border-grey-light">
                  Sigma 121
                </td>
                <td
                  class="py-4 px-2 md:px-4 border-b border-grey-light text-center"
                >
                  Monthly
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mb-12 md:mb-1">
          <router-link
            to="javascrip:void(0)"
            class="btn py-1 text-white font-medium"
            >View All</router-link
          >
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import Layout from "@/views/admin/Layout.vue";
import Helper from "@/providers/helper";

export default {
  name: "Dashboard",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Dashboard",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  /* components: {
    Layout
  }, */
  data() {
    return {
      referral: "spyowsbdsjdabasjhdgyuad/referral?/sigma101",
      totalUsersCount: 0,
      activeSubscribersData: null
    };
  },
  mounted() {
    let userStatsRef = Helper.getTotalUsersStats();
    if (userStatsRef && userStatsRef.on) {
      userStatsRef.on("value", snapshot => {
        this.totalUsersCount = snapshot.val();
      });
    }
    let activeSubscribersStatsRef = Helper.getActiveSubscriberStats();
    if (activeSubscribersStatsRef && activeSubscribersStatsRef.on) {
      activeSubscribersStatsRef.on("value", snapshot => {
        this.activeSubscribersData = snapshot.val();
      });
    }
  }
};
</script>

<style lang="postcss" scoped>
.buttons {
}

@screen md {
  .buttons {
    @apply px-5;
  }

  .listify li {
    @apply my-2;
  }
}

@screen lg {
  .buttons {
    @apply px-20;
  }
}

.buttons a {
  @apply block text-white my-2 py-2 px-2 w-auto mx-auto rounded-full border-2 bg-transparent;
}
</style>
